const tooltipWrappers = document.querySelectorAll('.tooltip-wrapper');
if (tooltipWrappers) {
  tooltipWrappers.forEach((tooltipWrapper) => {
    tooltipWrapper.addEventListener('click', toggleTooltip);
    tooltipWrapper.addEventListener('mouseenter', openTooltip);
    tooltipWrapper.addEventListener('mouseleave', closeTooltip);
  
    function toggleTooltip() {
      if (window.innerWidth <= 768) {
        tooltipWrappers.forEach((wrapper) => {
          if (wrapper !== tooltipWrapper) wrapper.classList.remove('tooltip-wrapper--visible');
        });

        tooltipWrapper.classList.toggle('tooltip-wrapper--visible');
      }   
    }

    function openTooltip() {
      if (window.innerWidth > 768) {
        tooltipWrapper.classList.add('tooltip-wrapper--visible');
      }
    }

    function closeTooltip() {  
      if (window.innerWidth > 768) {
        tooltipWrapper.classList.remove('tooltip-wrapper--visible');
      }
    }
  });
}
